import Table from "../../../Layout/Shared/Table";

export const FormList = ({ fields, headers, options}) => {
  return (
    <section>
      <Table fields={fields} headers={headers} options={options} />
    </section>
  );
};
